import { Benefits } from '@sunwebgroup/uds-ui/benefits'
import cn from 'classnames'
import * as React from 'react'
import { useCMSPageField } from '@/cms/fields'
import { useCheckoutSid, useCheckoutUsps } from '@/scopes/checkout/domain/hooks'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import styles from './CheckoutUsps.module.css'

function decodeHtmlEntities(text: string): string {
  return new DOMParser().parseFromString(text, 'text/html').documentElement.textContent || text
}

function CheckoutUspItems(props: { componentId: string }) {
  const { componentId } = props
  const { data, isLoading } = useCheckoutUsps(componentId)
  const { isDesktopSm } = useBreakpoints()
  if (isLoading)
    return ''
  if (!data)
    return ''

  return (
    <Benefits.Root className={cn(styles.wrapper)} display={isDesktopSm ? 'inlineLeft' : 'list'}>
      {data?.usps.map(({ text }) => (
        <Benefits.Item key={text} icon="CheckMarkSmall" title={decodeHtmlEntities(text)} />
      ))}
    </Benefits.Root>
  )
}

export function CheckoutUsps() {
  const sid = useCheckoutSid()
  const items = useCMSPageField('Checkout.usps')?.items ?? []

  if (!sid) {
    return null
  }

  return (
    <>
      {items?.map(({ componentId }) => {
        return <CheckoutUspItems key={componentId} componentId={componentId} />
      })}
    </>
  )
}
